import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=7305fbba&scoped=true&lang=pug&"
import script from "./FormGroup.vue?vue&type=script&lang=js&"
export * from "./FormGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=7305fbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7305fbba",
  null
  
)

/* custom blocks */
import block0 from "./FormGroup.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports